import { z } from 'zod';

export const AdminUserSchema = z.object({
  uid: z.string().min(1),
  email: z.string().email().nullable(),
  display_name: z.string().nullable(),
  is_super_admin: z.boolean(),
  disabled: z.boolean(),
  last_sign_in_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nullable(),
  providers: z.array(z.string()),
  // 'pending' for a self-serve signup awaiting admin approval; 'approved'
  // otherwise (missing field on the wire ⇒ approved for legacy users).
  approval_status: z.enum(['pending', 'approved']).default('approved'),
});

export const AdminUserListResponseSchema = z.object({
  users: z.array(AdminUserSchema),
  next_page_token: z.string().nullable(),
});

export const UpdateSuperAdminSchema = z.object({
  is_super_admin: z.boolean(),
});

export const UpdateUserDisabledSchema = z.object({
  disabled: z.boolean(),
});

export const PasswordResetLinkResponseSchema = z.object({
  link: z.string().url(),
});

export const CreateTenantSchema = z.object({
  name: z.string().min(1),
  slug: z
    .string()
    .min(1)
    .regex(/^[a-z0-9-]+$/),
  owner_email: z.string().email(),
});

export const RenameTenantSchema = z.object({
  name: z.string().min(1),
});

export const MembershipByEmailResponseSchema = z.object({
  uid: z.string().nullable(),
  email: z.string().email(),
  exists: z.boolean(),
});

export type ParsedAdminUser = z.infer<typeof AdminUserSchema>;
export type ParsedAdminUserListResponse = z.infer<typeof AdminUserListResponseSchema>;
export type ParsedUpdateSuperAdmin = z.infer<typeof UpdateSuperAdminSchema>;
export type ParsedUpdateUserDisabled = z.infer<typeof UpdateUserDisabledSchema>;
export type ParsedPasswordResetLinkResponse = z.infer<typeof PasswordResetLinkResponseSchema>;
export type ParsedCreateTenant = z.infer<typeof CreateTenantSchema>;
export type ParsedRenameTenant = z.infer<typeof RenameTenantSchema>;
export type ParsedMembershipByEmailResponse = z.infer<typeof MembershipByEmailResponseSchema>;
